import { isEmptyString } from "base/utils";
import { validatePositiveNumber } from "base/validation";
import FormRadioField from "base/FormRadioField";
import FormSelect from "base/FormSelect";
import FormTextField from "base/FormTextField";
import React, { useState } from "react";

const AddRecipePrepWork = ({ onRecipeUpdate }) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isPreheatNeeded, setIsPreheatNeeded] = useState(false);
  const [preheatTemp, setPreheatTemp] = useState("");

  const updatePreheat = (val) => {
    setIsPreheatNeeded(val);
  };

  const updatePreheatTemp = (val) => {
    if (val && !isEmptyString(val)) {
      //make sure there is always enough room for the value, while keeping the degree symbol right next to it
      let el = document.querySelector('.start-adornment input[type="number"]');
      if (el) {
        let charLength = val.length;
        el.style.minWidth = `${charLength}ch`;
      }
    }
    setPreheatTemp(val);
    let isValid = validatePositiveNumber(val);
    setErrorMessage(isValid);
    onRecipeUpdate("preheat_temp", val);
  };

  return (
    <>
      <FormRadioField
        fieldLabel="Does the oven need to be preheated?"
        value={isPreheatNeeded}
        onChange={updatePreheat}
        radioLabels={[
          { id: "yes", name: "Yes", value: true },
          { id: "no", name: "No", value: false },
        ]}
      />
      {isPreheatNeeded === true && (
        <div className="">
          <FormTextField
            className="start-adornment"
            error={errorMessage !== true}
            fieldLabel="Preheat Temperature"
            fieldSubText={errorMessage}
            fieldType="number"
            formClass="w-100"
            hasStartAdornment
            onChange={(val) => updatePreheatTemp(val)}
            placeholder="What should the oven be preheated to?"
            startAdornment="°F"
            value={preheatTemp}
          />
          {/* <FormSelect listOptions={["F", "C"]} defaultValue={"F"} /> */}
        </div>
      )}
    </>
  );
};

export default AddRecipePrepWork;